import { MultiLineTextProperty as MultiLineTextProp } from '../../peregrineFlowInterfaces';
import { Box, Typography, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { NodePropertyProp } from '../NodePropertyPane';
import { useCallback, useState, useEffect } from 'react';
import VariableAutocompleteTextField from './VariableAutocompleteTextField';

function MultiLineTextProperty({ property, onChange }: NodePropertyProp) {
    const p = property as unknown as MultiLineTextProp;
    const [text, setText] = useState<string>(p.value)
    const [changed, setChanged] = useState<boolean>(false);

    const sendOnChanged = useCallback(() => {
        if (!changed)
            return

        p.value = text;
        onChange?.(p)
        setChanged(false);
    }, [onChange, p, setChanged, changed, text]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (changed) {
                sendOnChanged();
            }
        }, 500);

        return () => clearTimeout(timer);
    }, [text, changed, sendOnChanged]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box display="flex" alignItems="center">
                <Typography variant="caption">{p.label}</Typography>
                {p.description && (
                    <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{p.description}</div>} componentsProps={{ tooltip: { sx: { maxWidth: 'none' } } }}>
                        <HelpOutline fontSize="small" sx={{ ml: 1, color: 'text.secondary', cursor: 'help', width: 16, height: 16 }} />
                    </Tooltip>
                )}
            </Box>
            <VariableAutocompleteTextField
                fullWidth
                multiline
                rows={p.rows || 4}
                value={text}
                variant="outlined"
                description={p.description}
                onValueChange={(v) => { setChanged(true); setText(v); }}
                onBlur={sendOnChanged}
                onKeyDownCapture={(e) => {
                    e.stopPropagation();
                }}
            />
        </Box>
    )
}

export default MultiLineTextProperty;
